import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EmptyList } from '../../components/EmptyList';
import { clearFilters } from '../../actions/filters';
import { loadReviews } from '../../actions/reviews/loadReviews';
import { loadQuestions } from '../../actions/questions';
import { getIsReviewTab } from '../../selectors/tabs';

export const EmptyListContainer = () => {
  const dispatch = useDispatch();
  const isReviewTab = useSelector(getIsReviewTab);

  const onClick = React.useCallback(() => {
    const loadFn = isReviewTab ? loadReviews : loadQuestions;

    dispatch(clearFilters());
    dispatch(loadFn());
  }, [dispatch, isReviewTab]);

  return <EmptyList onClick={onClick} />;
};
